export default __webpack_public_path__ + "static/media/TSDSI.a24ca597.png";